module.exports = __webpack_public_path__ + "img/40.45ee3e6c.jpg";